module.exports = __webpack_public_path__ + "static/media/smile-good.85befaec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/smiles/smile-good.svg
// module id = 146
// module chunks = 0